export function formatMoney(locale: string, currency: string, value: number) {
  return `${value.toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 2 })}`;
}
